<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('REPORTS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <component :is="type" />
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'ReportExportPage',

  components: {
    CustomersHabitation: () =>
      import('@/modules/reports/components/CustomersHabitation.vue'),
    BusinessCustomerHabitation: () =>
      import('@/modules/reports/components/BusinessCustomerHabitation.vue'),
    BusinessCustomerHabitationHistory: () =>
      import(
        '@/modules/reports/components/BusinessCustomerHabitationHistory.vue'
      ),
    CustomersCommunicationOptions: () =>
      import('@/modules/reports/components/CustomersCommunicationOptions.vue'),
    BuildingsAnalytics: () =>
      import('@/modules/reports/components/BuildingsAnalytics.vue'),
    EmergencyDevices: () =>
      import('@/modules/reports/components/EmergencyDevices.vue'),
    Tasks: () => import('@/modules/reports/components/Tasks.vue'),
    Invoices: () => import('@/modules/reports/components/Invoices.vue'),
    Medicall: () => import('@/modules/reports/components/Medicall.vue'),
    ActivityLog: () => import('@/modules/reports/components/ActivityLog.vue'),
    InvoicesAllLines: () =>
      import('@/modules/reports/components/InvoicesAllLines.vue'),
    Magazine: () => import('@/modules/reports/components/Magazine.vue')
  },

  props: {
    type: {
      type: String,
      required: true
    }
  }
};
</script>
